import { isNull } from 'lodash-es';
import ReactSelect from 'react-select';
import uuid from 'uuid';

import Icon from 'components/Icon';
import ScrollWrapper from 'components/ScrollWrapper';

const Menu = params => (
  <ScrollWrapper type="thin" viewClassName="Select-scrollbar-box">
    {ReactSelect.defaultProps.menuRenderer(params)}
  </ScrollWrapper>
);

const Indicator = () => <Icon icon="arrow-opening" />;

const Select = ({ searchable = false, onChange, name, ...rest }) => {
  const id = uuid();

  const handleChange = option => {
    if (isNull(option)) {
      return;
    }

    return onChange && onChange({ key: name, value: option.value });
  };

  const handleOpen = () => document.body.classList.add('_select_opened');
  const handleClose = () => document.body.classList.remove('_select_opened');

  return (
    <ReactSelect
      menuRenderer={Menu}
      arrowRenderer={Indicator}
      id={id}
      clearable={false}
      searchable={searchable}
      onOpen={handleOpen}
      onClose={handleClose}
      onChange={handleChange}
      {...rest}
    />
  );
};

export default Select;
